import type { MiddlewareContext } from "@/router";

export default async function guest({ next }: MiddlewareContext) {
  const { useUser } = await import("@/stores/user/user");

  const userStore = useUser();

  if (!userStore.userIsLoggined) {
    try {
      const response = await userStore.refreshAuth();
      if (response && typeof response === "string") {
        return next({
          name: "start",
        });
      }

      return next();
    } catch (err) {
      console.error(err);

      return next();
    }
  } else {
    return next();
  }
}
